// src/pages/Unsubscribe.js
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

const Unsubscribe = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const email = params.get('email');
    const token = params.get('token');

    if (!email || !token) {
      setStatus('error');
      return;
    }

    const process = async () => {
      try {
        // Verify token by checking it matches what we'd generate
        // Simple approach: just check the reader exists and update
        const docId = email.replace(/[.@]/g, '_');
        const docRef = doc(db, 'readers', docId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          await updateDoc(docRef, {
            newsletter: false,
            unsubscribedAt: new Date().toISOString(),
          });
          setStatus('success');
        } else {
          setStatus('success'); // Don't reveal if email exists or not
        }
      } catch {
        setStatus('error');
      }
    };

    process();
  }, [params]);

  return (
    <div className="page-content">
      <div style={{ maxWidth: 440, margin: '80px auto', textAlign: 'center', padding: '48px 32px', background: 'rgba(255,255,255,0.8)', borderRadius: 16 }}>
        {status === 'processing' && <p>Processing...</p>}
        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
            <h2 style={{ marginBottom: 8 }}>Unsubscribed</h2>
            <p style={{ color: '#6B7280' }}>You've been removed from The Avenir Newsletter.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✗</div>
            <h2 style={{ marginBottom: 8 }}>Something went wrong</h2>
            <p style={{ color: '#6B7280' }}>Please try again or contact info@avenir.com.ai</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;